import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ReservationsModel } from '../models/reservations-model';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ReservationsService {
  constructor(private http: HttpClient ) {
  }
  public addReservation(reservation: ReservationsModel): Observable<ReservationsModel> {
    return this.http.post<ReservationsModel>(environment.baseUrl+'/reservations/AddReservation/'+reservation.siteId, reservation,{"headers":{ Anonymous: 'Anonymous' }});
  }
}
